import * as React from 'react'
import { AppRoute } from '@chegg-wt/core/types/core'
import { DashboardUpsellCopy } from '@chegg-wt/core/types/features'
import { addRedirectQueryToRoute, routeToHref } from '@chegg-wt/core/utils/routes'
import AppLink from '../AppLink'
import { useRoutesContext } from '../RoutesContext'
import { CITATION_UPSELL, CITATION_UPSELL_ITEM, CITATION_CTA } from './utils/testIds'
import { PanelContainer, PanelHeading, CTAButton, FeatureListContainer } from './styles'
import { FeaturePanelDispatchProps } from './types'
import { FeatureItem } from './common'
import * as DomIds from './domIds'

interface CitationPanelProps extends FeaturePanelDispatchProps {
  redirectTo: AppRoute
  upsellCopy: DashboardUpsellCopy
  onClickCTA: () => void
}

const CitationPanel: React.FC<CitationPanelProps> = ({
  redirectTo,
  upsellCopy,
  onClickCTA,
}) => {
  const { toUpgrade } = useRoutesContext()
  const upgradeRoute = addRedirectQueryToRoute(toUpgrade(), routeToHref(redirectTo))

  const { FEATURE_LIST, UPSELL_HEADING, CTA_COPY } = upsellCopy.citation
  const features = FEATURE_LIST.map((text, index) => {
    return (
      <FeatureItem
        key={text}
        featureText={text}
        testId={`${CITATION_UPSELL_ITEM}_${index}`}
      />
    )
  })
  const handleClickCTA = () => {
    onClickCTA()
  }
  return (
    <PanelContainer data-test={CITATION_UPSELL} id={DomIds.CreateCitationPanelId}>
      <PanelHeading center>{UPSELL_HEADING}</PanelHeading>
      <FeatureListContainer>{features}</FeatureListContainer>
      <AppLink route={upgradeRoute}>
        <CTAButton
          onClick={handleClickCTA}
          size="small"
          data-test={CITATION_CTA}
          aria-label={CTA_COPY}
        >
          {CTA_COPY}
        </CTAButton>
      </AppLink>
    </PanelContainer>
  )
}

export default CitationPanel
